import React from "react";
import SingleContentPage from "../Shared/SingleContentPage";

const DirectorRankingCell = () => {
  return <SingleContentPage title="Director Ranking Cell" moduleKey="director-ranking-cell" />;
};

export default DirectorRankingCell;
